import React from 'react';

import styles from './Footer.module.scss';

interface FooterProps {
  children: React.ReactNode;
}

export const Footer: React.FC<FooterProps> = ({ children }) => {
  return (
    <div className={styles.footer}>
      <div className={styles.buttonWrapper}>{children}</div>
    </div>
  );
};
